import { importProvidersFrom } from '@angular/core';
import { NgxMatDateFormats, NGX_MAT_DATE_FORMATS } from '@angular-material-components/datetime-picker';
import { MAT_FORM_FIELD_DEFAULT_OPTIONS } from '@angular/material/form-field';
import { NgxMatMomentModule } from '@angular-material-components/moment-adapter';
import { FIREBASE_OPTIONS } from '@angular/fire/compat';
import { AngularFirestoreModule } from '@angular/fire/compat/firestore';
import { ApplicationConfig } from '@angular/platform-browser';
import { provideAnimations } from '@angular/platform-browser/animations';
import { provideRouter } from '@angular/router';
import { LocationApiService } from '@xpo-ltl-2.0/sdk-location';
import { xpoConfigManagerProvider } from '@xpo-ltl/config-manager';

import { xpoAuthConfigManagerConfiguration } from '@xpo-ltl/ngx-auth';
import { XpoConfirmDialogModule } from '@xpo-ltl/ngx-ltl-core/confirm-dialog';
import { XpoSnackBarModule } from '@xpo-ltl/ngx-ltl-core/snack-bar';
import { SdkAppMetadataModule } from '@xpo-ltl/sdk-appmetadata';
import { SdkInfrastructureModule } from '@xpo-ltl/sdk-infrastructure';
import { SdkUserPreferenceModule } from '@xpo-ltl/sdk-userpreference';
import { environment } from '../environments/environment';
import { appRoutes } from './app.routes';
import { PendingChangesGuard } from './batch-framework/guards/pending-changes/pending-changes.guard';

const DATE_PICKER_FORMAT = 'MM/DD/YYYY hh:mm A';

const CUSTOM_DATE_FORMATS: NgxMatDateFormats = {
  parse: { dateInput: DATE_PICKER_FORMAT },
  display: {
    dateInput: DATE_PICKER_FORMAT,
    monthYearLabel: 'MMM YYYY',
    dateA11yLabel: 'LL',
    monthYearA11yLabel: 'MMMM YYYY',
  },
};

export const appConfig: ApplicationConfig = {
  providers: [
    provideRouter(appRoutes),
    provideAnimations(),
    importProvidersFrom(
      SdkAppMetadataModule,
      SdkUserPreferenceModule,
      SdkInfrastructureModule,
      AngularFirestoreModule,
      XpoSnackBarModule,
      XpoConfirmDialogModule,
      NgxMatMomentModule
    ),
    xpoConfigManagerProvider(
      xpoAuthConfigManagerConfiguration(
        {
          firebaseOptions: environment.firebase,
          configFileUrl: './assets/config.json',
        },
        { enableFirebaseApis: true }
      )
    ),
    { provide: FIREBASE_OPTIONS, useValue: environment.firebase },
    LocationApiService,
    PendingChangesGuard,
    { provide: NGX_MAT_DATE_FORMATS, useValue: CUSTOM_DATE_FORMATS },
    { provide: MAT_FORM_FIELD_DEFAULT_OPTIONS, useValue: { appearance: 'outline' } },
  ],
};
